import { useState } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { RiDeleteBin7Line } from 'react-icons/ri';
import '../../style/mobile/cart/MCart.scss';
import img1 from "../../../assets/cart/credit-card.png";

const MCart=()=>{

  let discount_code_list = [
    {
      id: 1,
      code: "12dr57",
      discount: 0.1,
    },
    {
      id: 2,
      code: "12d8887",
      discount: 0.2,
    },
    {
      id: 3,
      code: "sd34890",
      discount: 0.05,
    },
  ];


  let data = [
    {
      id:1,
      name:"آزمون تاریخ معاصر",
      price:90000,
      masterPrice:100000,
      text:"از درس اول تا پنجم",
      badge:"10%"
    },
    {
      id:2,
      name:"آزمون تاریخ معاصر",
      price:90000,
      masterPrice:100000,
      text:"از درس اول تا پنجم",
      badge:"10%"
    },
  ]

  // ----total-price----------------------
  let total_price = 0;
  for (let i = 0; i < data.length; i++) {
    if (data[i].badge) {
      total_price += data[i].price;
    } else {
      total_price += data[i].masterPrice;
    }
  }
  //-------discount----------------------
  const [discount, set_discount] = useState(0);
  const get_discount = () => {
    let code = document.querySelector("#discount-code-input").value;
    for (let j = 0; j < discount_code_list.length; j++) {
      if (code === discount_code_list[j].code) {
        set_discount(discount_code_list[j].discount);
      }
    }
  };

  //----payable-cost--and discount-amount------------------
  let discount_amount = discount * total_price;
  let payable_cost = total_price - discount_amount;
  //---------------------------------------------------

  const goBack=()=>{
    window.history.back();
  }

  return(
    <div className="MCart">
      <div className="MCart-title-box">
        <div className="MCart-title-box-text">سبد خرید</div>
        <div className="MCart-title-box-back-btn" onClick={goBack}>
          <IoIosArrowBack className="MCart-title-box-back-btn-icon"/>
        </div>
      </div>
      <div className="MCart-body">
        {data.map((item,index)=>(
          <div className="MCart-body-item">
            <div className="MCart-body-item-delet-btn">
              حذف
              <RiDeleteBin7Line className="MCart-body-item-delete-icon"/>
            </div>
            <div className="MCart-body-item-header">
              <div className="MCart-body-item-header-row-number">{index+1}</div>
              {/* <RiDeleteBin7Line className="MCart-body-item-header-delete-icon"/> */}
            </div>
            <div className="MCart-body-item-name">
              نام آزمون :
              <span>{item.name}</span>
            </div>
            <div className="MCart-body-item-text">
              توضیحات :
              <span>{item.text}</span>
            </div>
            <div className="MCart-body-item-price">
              مبلغ :
              <span>{item.price ? item.price : item.masterPrice} تومان</span>
            </div>
          </div>
        ))}
        <div className="MCart-body-payment-box">
          <div className="MCart-body-payment-box-discount-box">
            <div className="MCart-body-payment-box-discount-box-btn" onClick={get_discount}>
              ثبت کد
            </div>
            <input
              className="MCart-body-payment-box-discount-box-input"
              type="text"
              name="discount-code"
              id="discount-code-input"
              placeholder="اگر کد تخفیف دارید اینجا بنویسید"
            />
          </div>
          <div className="MCart-body-payment-box-line"></div>
          <div className="MCart-body-payment-box-total-cost-box">
            <div className="MCart-body-payment-box-total-cost-box-title">جمع مبالغ</div>
            <div className="MCart-body-payment-box-total-cost-box-amount">
              {" "}
              {total_price} <span>تومان</span>
            </div>
          </div>
          <div className="MCart-body-payment-box-discount-amount-box">
            <div className="MCart-body-payment-box-discount-amount-box-title">میزان تخفیف</div>
            <div className="MCart-body-payment-box-discount-amount-box-amount">
              {discount_amount} <span>تومان</span>
            </div>
          </div>
          <div className="MCart-body-payment-box-line"></div>
          <div className="MCart-body-payment-box-payable-cost-box">
            <div className="MCart-body-payment-box-payable-cost-box-title">مبلغ پرداختی</div>
            <div className="MCart-body-payment-box-payable-cost-box-amount">
              {payable_cost} <span>تومان</span>
            </div>
          </div>
          <div className="MCart-body-payment-box-line"></div>
          <div className="MCart-body-payment-box-description-box">
            <div className="MCart-body-payment-box-description-box-text">
              پرداخت با کلیه کارت های عضو شبکه شتاب
            </div>
            <img src={img1} alt="card-img" />
          </div>
          <div className="MCart-body-payment-box-btn-container">
            <div className="MCart-body-payment-box-btn-container-btn">پرداخت</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MCart;